import { useQuery } from '@tanstack/react-query';

import { dashboardV2Client } from '../api/client';
import { dashboardV2QueryKeys } from '../api/queryKeys';
import { NeedsApprovalData } from '../api/types';

// Shifts with a pending decision + fraction sub-state.
const useNeedsApprovalQueue = (agencyId: number) =>
  useQuery<NeedsApprovalData>({
    queryKey: dashboardV2QueryKeys.needsApproval(agencyId),
    queryFn: () => dashboardV2Client.getNeedsApproval(agencyId),
    enabled: agencyId != null,
    staleTime: 30_000,
  });

export default useNeedsApprovalQueue;
